import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { RelationshipV2 } from 'support/types';
import { ConnectionSetupTableRow } from 'components/ConnectionSetupTable/ConnectionSetupTable';
import { StepStatus } from 'components/Display/Steps/Steps';

type Params = {
  stepStatus: StepStatus;
  relationship: RelationshipV2 | undefined;
  isSender: boolean;
  routeTo: (subPath: 'goLiveRelationship', params: Record<string, string>) => string;
  partnerId: string;
};

export const useGoLiveStep = ({ stepStatus, relationship, isSender, routeTo, partnerId }: Params) => {
  const { t } = useTranslation();

  const rows: Array<ConnectionSetupTableRow> = useMemo(
    () => [
      {
        id: 'exchange-first-live-document',
        status: stepStatus === 'completed' ? 'DONE' : 'TODO',
        title: t('connections:relationshipDetails.steps.goLive.tasks.exchangeFirstLiveDocument'),
        ownership: isSender ? 'you' : 'trade_partner',
        actionRequired: isSender && stepStatus === 'current',
        path:
          isSender && relationship
            ? routeTo('goLiveRelationship', { partnerId, relationshipId: relationship.id })
            : undefined,
      },
    ],
    [stepStatus, relationship, isSender, routeTo, partnerId, t],
  );

  return { rows };
};
